import { render, staticRenderFns } from "./addSecondSubject.vue?vue&type=template&id=77e87320&scoped=true&"
import script from "./addSecondSubject.vue?vue&type=script&lang=js&"
export * from "./addSecondSubject.vue?vue&type=script&lang=js&"
import style0 from "./addSecondSubject.vue?vue&type=style&index=0&id=77e87320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e87320",
  null
  
)

export default component.exports